import { h } from 'preact';

export const Play = () => (
  <svg
    width='54'
    height='54'
    viewBox='0 0 38 39'
    fill='none'
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    aria-label={window.TMW.Strings.icons.play}
    aria-hidden='true'
  >
    <title>{window.TMW.Strings.icons.play}</title>
    <path d='M24.5 18.3046C25.1667 18.6895 25.1667 19.6518 24.5 20.0367L16.25 24.7998C15.5833 25.1847 14.75 24.7036 14.75 23.9338L14.75 14.4075C14.75 13.6377 15.5833 13.1566 16.25 13.5415L24.5 18.3046Z' fill='currentColor'/>
  </svg>
);

export const Pause = () => (
  <svg
    width='54'
    height='54'
    viewBox='0 0 54 54'
    fill='none'
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    aria-label={window.TMW.Strings.icons.pause}
    aria-hidden='true'
  >
    <title>{window.TMW.Strings.icons.pause}</title>
    <line x1='22.25' y1='19.25' x2='22.25' y2='33.75' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'/>
    <line x1='31.75' y1='33.75' x2='31.75' y2='19.25' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'/>
  </svg>
);

export const Mute = () => (
  <svg 
    width='50' 
    height='50' 
    viewBox='0 0 50 50' 
    fill='none' 
    xmlns='http://www.w3.org/2000/svg'
    focusable='false'
    aria-label={window.TMW.Strings.icons.mute}
    aria-hidden='true'
  >
    <title>{window.TMW.Strings.icons.mute}</title>
    <g clipPath='url(#clip0_359_8321)'>
      <g clipPath='url(#clip1_359_8321)'>
        <path d='M24.1438 34.8803L18.4379 28.8368H15.2607C14.1964 28.8368 13.334 27.9744 13.334 26.9104V23.7824C13.334 22.7184 14.1964 21.8557 15.2607 21.8557H18.4381L24.1438 15.8123V34.8803Z' fill='currentColor'/>
        <path d='M27.1392 19.4995C29.0421 20.4756 30.3774 22.7601 30.3774 25.4228C30.3774 27.8024 29.3112 29.88 27.7265 30.9914' stroke='currentColor' strokeWidth='1.35681' strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M30.2651 15.8479C33.4107 17.4611 35.6175 21.2376 35.6175 25.639C35.6175 29.5721 33.855 33.0062 31.2358 34.8436' stroke='currentColor' strokeWidth='1.35681' strokeLinecap='round' strokeLinejoin='round'/>
      </g>
      <line x1='12.6707' y1='35.6237' x2='36.6707' y2='14.6237' stroke='currentColor'/>
    </g>
  </svg>
);

export const Unmute = () => (
  <svg 
    width='50' 
    height='50' 
    viewBox='0 0 50 50' 
    fill='none' 
    xmlns='http://www.w3.org/2000/svg'
    focusable='false'
    aria-label={window.TMW.Strings.icons.unmute}
    aria-hidden='true'
  >
    <title>{window.TMW.Strings.icons.unmute}</title>
    <g clipPath='url(#clip0_359_8321)'>
      <g clipPath='url(#clip1_359_8321)'>
        <path d='M24.1438 34.8803L18.4379 28.8368H15.2607C14.1964 28.8368 13.334 27.9744 13.334 26.9104V23.7824C13.334 22.7184 14.1964 21.8557 15.2607 21.8557H18.4381L24.1438 15.8123V34.8803Z' fill='currentColor'/>
        <path d='M27.1392 19.4995C29.0421 20.4756 30.3774 22.7601 30.3774 25.4228C30.3774 27.8024 29.3112 29.88 27.7265 30.9914' stroke='currentColor' strokeWidth='1.35681' strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M30.2651 15.8479C33.4107 17.4611 35.6175 21.2376 35.6175 25.639C35.6175 29.5721 33.855 33.0062 31.2358 34.8436' stroke='currentColor' strokeWidth='1.35681' strokeLinecap='round' strokeLinejoin='round'/>
      </g>
    </g>
  </svg>
);

export const SmallPlay = () => (
  <svg 
    width='21' 
    height='21' 
    viewBox='0 0 21 21' 
    fill='none' 
    xmlns='http://www.w3.org/2000/svg'
    focusable='false'
    aria-label={window.TMW.Strings.icons.playImage}
    aria-hidden='true'
  >
    <title>{window.TMW.Strings.icons.playImage}</title>
    <circle cx='10.5' cy='10.5' r='10.5' fill='white'/>
    <path d='M15.3906 10.5006L8.04062 14.7441L8.04062 6.25706L15.3906 10.5006Z' fill='black'/>
  </svg>
);

export const SliderArrow = () => (
  <svg 
    width='54' 
    height='54' 
    viewBox='0 0 54 54' 
    fill='none' 
    xmlns='http://www.w3.org/2000/svg'
    focusable='false'
    aria-label={window.TMW.Strings.icons.sliderArrow}
    aria-hidden='true'
  >
    <title>{window.TMW.Strings.icons.sliderArrow}</title>
    <rect width='54' height='54' fill='black'/>
    <path d='M36.7071 27.7071C37.0976 27.3166 37.0976 26.6834 36.7071 26.2929L30.3431 19.9289C29.9526 19.5384 29.3195 19.5384 28.9289 19.9289C28.5384 20.3195 28.5384 20.9526 28.9289 21.3431L34.5858 27L28.9289 32.6569C28.5384 33.0474 28.5384 33.6805 28.9289 34.0711C29.3195 34.4616 29.9526 34.4616 30.3431 34.0711L36.7071 27.7071ZM18 28L36 28L36 26L18 26L18 28Z' fill='white'/>
  </svg>
);
